import React from "react";
import { ShieldAlert } from "lucide-react";
import { Card } from "@/components/ui/card";

export default function ScamWarningWidget() {
  return (
    <Card className="p-5 rounded-2xl border border-gray-100 shadow-sm">
      <div className="flex justify-center mb-3">
        <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center">
          <ShieldAlert className="w-6 h-6 text-[#f05537]" />
        </div>
      </div>

      <h3 className="text-sm font-bold text-gray-900 text-center mb-2">
        Never pay anyone to get a job
      </h3>

      <p className="text-xs text-gray-500 text-center mb-3 leading-relaxed">
        Fraudsters may ask you to pay money to get a job or earn more.  
        Never make such payments.
      </p>

      <div className="text-center">
        <button
          type="button"
          className="text-[#2557a7] text-sm font-bold hover:underline bg-transparent border-none p-0 cursor-pointer"
        >
          Learn more
        </button>
      </div>
    </Card>
  );
}
